import { useAuth } from "@/contexts/AuthContext";
import { useSubscription } from "@/hooks/useSubscription";
import { AlertTriangle } from "lucide-react";
import { Link } from "react-router-dom";

export default function BillingStatusBanner() {
  const { user } = useAuth();
  const { subscription } = useSubscription(user?.id);

  if (!user || !subscription) return null;
  const status = subscription.status;
  if (status !== "past_due" && status !== "halted") return null;

  return (
    <div
      role="alert"
      className="w-full text-center px-4 py-2.5 text-sm flex items-center justify-center gap-3 flex-wrap"
      style={{ background: "hsl(38 95% 16%)", color: "hsl(40 95% 88%)", borderBottom: "1px solid hsl(38 80% 30%)" }}
    >
      <span className="flex items-center gap-2">
        <AlertTriangle size={15} />
        We couldn't process your last payment. Update your payment method to keep your access.
      </span>
      <Link
        to="/pricing"
        className="underline font-semibold hover:opacity-80 transition-opacity"
      >
        Update payment method
      </Link>
    </div>
  );
}
